import { ViewTableCell } from "@design-system/ViewTable/ViewTableCell";
import { useCategoriesById } from "@hooks/useCategoriesById";
import { TransactionCategory } from "@components/transactions/TransactionCategory";
import { DeletedCategory } from "@components/history/components/DeletedCategory";
import { Tag } from "@design-system/Tag/Tag";
import { TransactionListItem } from "@common/schemas/transaction.schema";
import { Category } from "@common/types/category";
import { CellContext } from "@tanstack/react-table";
import type { ViewTableFeatures } from "@design-system/ViewTable/core/table";
import { HistoryCreatedTransactionDetailsRow } from "../views/historyCreatedTransactionDetailsViewConfig";
import styles from "./HistoryTransactionsDetailsCells.module.scss";

export const HistoryTransactionCategoryCell = ({
    row,
}: CellContext<
    ViewTableFeatures,
    HistoryCreatedTransactionDetailsRow,
    Partial<Category>
>) => {
    const categories = useCategoriesById();
    const categoryId = row.original.category?.id;

    if (!categoryId || typeof categoryId !== "string") {
        return (
            <ViewTableCell>
                <DeletedCategory label="Uncategorized" />
            </ViewTableCell>
        );
    }

    const category = categories[categoryId];

    if (category) {
        return (
            <ViewTableCell>
                <TransactionCategory
                    transaction={
                        {
                            ...row.original,
                            categoryId,
                            category,
                        } as unknown as TransactionListItem
                    }
                />
            </ViewTableCell>
        );
    }

    return (
        <ViewTableCell>
            <div className={styles.deletedContainer}>
                <DeletedCategory label={row.original.category.label ?? ""} />
                <Tag color="neutral" outline>
                    Deleted
                </Tag>
            </div>
        </ViewTableCell>
    );
};
